import request from '../utils/request';

export default (partyType, partyCode) => request('/reports/performance', { params: { partyType, partyCode } });
